import './App.css';
import {
  Anchor,
  Badge,
  Button,
  Card,
  Checkbox,
  CheckboxProps,
  Col,
  Divider,
  Dropdown,
  Flex,
  Form,
  MenuProps,
  message,
  Modal,
  Row,
  Select,
  Skeleton,
  Space,
  Statistic,
  Typography,
} from 'antd';
import useSWR, { useSWRConfig } from 'swr';
import 'react-quill/dist/quill.snow.css';
import cookie from 'react-cookies';

import { useNavigate } from 'react-router-dom';
import { DownOutlined, LeftCircleOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';

import type { StatisticProps } from 'antd';
import CountUp from 'react-countup';
import { usePageAnimation } from './AnimationContext';

const formatter: StatisticProps['formatter'] = value => (
  <CountUp end={value as number} separator=',' />
);

const { Title } = Typography;

const fetcher = async (url: string) => {
  const token = cookie.load('token');
  const res = await fetch(url, {
    headers: new Headers({
      'Access-Control-Allow-Origin': '*',
      Authorization: `Bearer ${token}`,
    }),
  });
  const json = await res.json();
  if (!json.success) {
    const error = new Error((await json).message);
    throw error;
  }
  return json;
};

const MarshmallowCard = ({
  data,
  editMode,
  checkedList,
  setCheckedList,
  categories,
  lastRead
}: any) => {
  const n = useNavigate();
  const { mutate } = useSWRConfig();
  const token = cookie.load('token');
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [editForm] = Form.useForm();
  const checked =
    checkedList.find((item: any) => item === data.id) !== undefined;
  const onChange: CheckboxProps['onChange'] = e => {
    if (checked) {
      const newCheckedList = checkedList.filter(
        (item: any) => item !== data.id
      );
      setCheckedList(newCheckedList);
    } else {
      setCheckedList([...checkedList, data.id]);
    }
  };
  const moveMarshmallow = async (values: any) => {
    setEditOpen(false);
    const response = await (
      await fetch('https://api.lynne.com.cn/marshmallowManage/move', {
        method: 'POST',
        body: JSON.stringify({
          id: data.id,
          moveto: values.id,
        }),
        headers: new Headers({
          'Access-Control-Allow-Origin': '*',
          'Content-type': 'Application/json',
          Authorization: `Bearer ${token}`,
        }),
      })
    ).json();
    if (response.success) {
      message.success(response.message);
      mutate(`https://api.lynne.com.cn/marshmallowManage/list`);
      mutate(`https://api.lynne.com.cn/marshmallowManage/category`);
    } else {
      message.error(response.message);
    }
  };
  const deleteMarshmallow = async () => {
    setDeleteOpen(false);
    const response = await (
      await fetch('https://api.lynne.com.cn/marshmallowManage/delete', {
        method: 'POST',
        body: JSON.stringify({
          id: data.id,
        }),
        headers: new Headers({
          'Access-Control-Allow-Origin': '*',
          'Content-type': 'Application/json',
          Authorization: `Bearer ${token}`,
        }),
      })
    ).json();
    if (response.success) {
      message.success(response.message);
      mutate(`https://api.lynne.com.cn/marshmallowManage/list`);
      mutate(`https://api.lynne.com.cn/marshmallowManage/category`);
    } else {
      message.error(response.message);
    }
  };
  const items: MenuProps['items'] = [
    {
      label: '公开此稿件',
      key: '1',
    },
    {
      label: '隐藏此稿件',
      key: '2',
    },
    {
      label: '移动此稿件',
      key: '3',
    },
    {
      label: '删除此稿件',
      key: '4',
    },
    {
      label: '收纳此稿件',
      key: '5',
    },
  ];
  const handleMenuClick: MenuProps['onClick'] = async e => {
    if (e.key === '1') {
      const response = await (
        await fetch('https://api.lynne.com.cn/marshmallowManage/show', {
          method: 'POST',
          body: JSON.stringify({
            id: data.id,
            public_show: 1,
          }),
          headers: new Headers({
            'Access-Control-Allow-Origin': '*',
            'Content-type': 'Application/json',
            Authorization: `Bearer ${token}`,
          }),
        })
      ).json();
      if (response.success) {
        message.success(response.message);

        mutate(`https://api.lynne.com.cn/marshmallowManage/list`);
        mutate(`https://api.lynne.com.cn/marshmallowManage/category`);
      } else {
        message.error(response.message);
      }
    } else if (e.key === '2') {
      const response = await (
        await fetch('https://api.lynne.com.cn/marshmallowManage/show', {
          method: 'POST',
          body: JSON.stringify({
            id: data.id,
            public_show: 0,
          }),
          headers: new Headers({
            'Access-Control-Allow-Origin': '*',
            'Content-type': 'Application/json',
            Authorization: `Bearer ${token}`,
          }),
        })
      ).json();
      if (response.success) {
        message.success(response.message);
        mutate(`https://api.lynne.com.cn/marshmallowManage/list`);
        mutate(`https://api.lynne.com.cn/marshmallowManage/category`);
      } else {
        message.error(response.message);
      }
    } else if (e.key === '3') {
      setEditOpen(true);
    } else if (e.key === '4') {
      setDeleteOpen(true);
    } else if (e.key === '5') {
      const response = await (
        await fetch('https://api.lynne.com.cn/marshmallowManage/archive', {
          method: 'POST',
          body: JSON.stringify({
            id: data.id,
            archived: 1,
          }),
          headers: new Headers({
            'Access-Control-Allow-Origin': '*',
            'Content-type': 'Application/json',
            Authorization: `Bearer ${token}`,
          }),
        })
      ).json();
      if (response.success) {
        message.success(response.message);
        mutate(`https://api.lynne.com.cn/marshmallowManage/list`);
        mutate(`https://api.lynne.com.cn/marshmallowManage/category`);
      } else {
        message.error(response.message);
      }
    }
  };
  const menuProps = {
    items,
    onClick: handleMenuClick,
  };
  return (
    <>
      <Modal
        open={editOpen}
        title='修改分类'
        okText='修改'
        cancelText='取消'
        okButtonProps={{ autoFocus: true, htmlType: 'submit' }}
        onCancel={() => setEditOpen(false)}
        destroyOnClose
        modalRender={dom => (
          <Form
            layout='vertical'
            form={editForm}
            name='editCategory'
            clearOnDestroy
            onFinish={values => moveMarshmallow(values)}>
            {dom}
          </Form>
        )}>
        <Form.Item
          name='id'
          label='请选择分类'
          rules={[
            {
              required: true,
              message: '请选择分类',
            },
          ]}>
          <Select style={{ width: '100%' }} options={categories} />
        </Form.Item>
      </Modal>
      <Modal
        open={deleteOpen}
        title='删除投稿'
        okText='删除'
        okType='danger'
        cancelText='取消'
        onCancel={() => setDeleteOpen(false)}
        destroyOnClose
        onOk={() => deleteMarshmallow()}
        >
        确定要删除这个投稿吗？
      </Modal>
      <Dropdown menu={menuProps} trigger={['contextMenu']}>
        <Card
          className="marshmallow-card"
          hoverable
          bordered={false}
          style={{ width: '100%' }}
          onClick={() => {
            if (editMode) {
              if (checked) {
                const newCheckedList = checkedList.filter(
                  (item: any) => item !== data.id
                );
                setCheckedList(newCheckedList);
              } else {
                setCheckedList([...checkedList, data.id]);
              }
            } else {
              // 获取当前页面滚动参数并自动保存至session
              const scrollData =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop ||
                window.scrollY ||
                0;
              sessionStorage.setItem('scroll', scrollData.toString());
              sessionStorage.setItem('lastRead', data.id.toString());
              n(`/dashboard/marshmallow/${data.id}`);
            }
          }}>
          <Space style={{ width: '100%' }}>
            {editMode && <Checkbox checked={checked} onChange={onChange} />}
            {data.title}
            {data.public_show ? (
              <Badge color='green' count='公开展示中' />
            ) : (
              <Badge color='blue' count='暂未公开展示' />
            )}
            {
              lastRead === data.id && <Badge color='purple' count='上次阅读到这篇喔' />
            }
          </Space>
        </Card>
      </Dropdown>
    </>
  );
};

const MarshmallowCategoryCard = ({ marshmallow, categories, lastRead }: any) => {
  const { mutate } = useSWRConfig();
  const token = cookie.load('token');
  const [editMode, setEditMode] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [editForm] = Form.useForm();
  const [checkedList, setCheckedList] = useState<number[]>([]);
  const moveMarshmallow = async (values: any) => {
    setEditOpen(false);
    let flag = true;
    for (let id of checkedList) {
      const response = await (
        await fetch('https://api.lynne.com.cn/marshmallowManage/move', {
          method: 'POST',
          body: JSON.stringify({
            id: id,
            moveto: values.id,
          }),
          headers: new Headers({
            'Access-Control-Allow-Origin': '*',
            'Content-type': 'Application/json',
            Authorization: `Bearer ${token}`,
          }),
        })
      ).json();
      if (response.success) {
      } else {
        message.error(response.message);
        flag = false;
        break;
      }
    }
    if (flag) {
      message.success('设置成功');
    }
    mutate(`https://api.lynne.com.cn/marshmallowManage/list`);
    mutate(`https://api.lynne.com.cn/marshmallowManage/category`);
    setCheckedList([]);
  };
  const deleteMarshmallow = async () => {
    setDeleteOpen(false);
    let flag = true;
    for (let id of checkedList) {
      const response = await (
        await fetch('https://api.lynne.com.cn/marshmallowManage/delete', {
          method: 'POST',
          body: JSON.stringify({
            id: id,
          }),
          headers: new Headers({
            'Access-Control-Allow-Origin': '*',
            'Content-type': 'Application/json',
            Authorization: `Bearer ${token}`,
          }),
        })
      ).json();
      if (response.success) {
      } else {
        message.error(response.message);
        flag = false;
        break;
      }
    }
    if (flag) {
      message.success('删除成功');
    }
    mutate(`https://api.lynne.com.cn/marshmallowManage/list`);
    mutate(`https://api.lynne.com.cn/marshmallowManage/category`);
    setCheckedList([]);
  };
  const handleMenuClick: MenuProps['onClick'] = async e => {
    if (checkedList.length === 0) {
      message.error('笨蛋！明明一个都没有选中！');
      return;
    }
    if (e.key === '1') {
      let flag = true;
      for (let id of checkedList) {
        const response = await (
          await fetch('https://api.lynne.com.cn/marshmallowManage/show', {
            method: 'POST',
            body: JSON.stringify({
              id: id,
              public_show: 1,
            }),
            headers: new Headers({
              'Access-Control-Allow-Origin': '*',
              'Content-type': 'Application/json',
              Authorization: `Bearer ${token}`,
            }),
          })
        ).json();
        if (response.success) {
        } else {
          message.error(response.message);
          flag = false;
          break;
        }
      }
      mutate(`https://api.lynne.com.cn/marshmallowManage/list`);
      mutate(`https://api.lynne.com.cn/marshmallowManage/category`);
      if (flag) {
        message.success('设置成功');
      }
      setCheckedList([]);
    } else if (e.key === '2') {
      let flag = true;
      for (let id of checkedList) {
        const response = await (
          await fetch('https://api.lynne.com.cn/marshmallowManage/show', {
            method: 'POST',
            body: JSON.stringify({
              id: id,
              public_show: 0,
            }),
            headers: new Headers({
              'Access-Control-Allow-Origin': '*',
              'Content-type': 'Application/json',
              Authorization: `Bearer ${token}`,
            }),
          })
        ).json();
        if (response.success) {
        } else {
          message.error(response.message);
          flag = false;
          break;
        }
      }
      mutate(`https://api.lynne.com.cn/marshmallowManage/list`);
      mutate(`https://api.lynne.com.cn/marshmallowManage/category`);
      if (flag) {
        message.success('设置成功');
      }
      setCheckedList([]);
    } else if (e.key === '3') {
      setEditOpen(true);
    } else if (e.key === '4') {
      setDeleteOpen(true);
    } else if (e.key === '5') {
      let flag = true;
      for (let id of checkedList) {
        const response = await (
          await fetch('https://api.lynne.com.cn/marshmallowManage/archive', {
            method: 'POST',
            body: JSON.stringify({
              id: id,
              archived: 1,
            }),
            headers: new Headers({
              'Access-Control-Allow-Origin': '*',
              'Content-type': 'Application/json',
              Authorization: `Bearer ${token}`,
            }),
          })
        ).json();
        if (response.success) {
        } else {
          message.error(response.message);
          flag = false;
          break;
        }
      }
      mutate(`https://api.lynne.com.cn/marshmallowManage/list`);
      mutate(`https://api.lynne.com.cn/marshmallowManage/category`);
      if (flag) {
        message.success('设置成功');
      }
      setCheckedList([]);
    }
  };
  const items: MenuProps['items'] = [
    {
      label: '批量公开',
      key: '1',
    },
    {
      label: '批量隐藏',
      key: '2',
    },
    {
      label: '批量移动',
      key: '3',
    },
    {
      label: '批量删除',
      key: '4',
    },
    {
      label: '批量收纳',
      key: '5',
    },
  ];

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  const selectAll = () => {
    if (checkedList.length === marshmallow.data.length) {
      setCheckedList([]);
    } else {
      setCheckedList(marshmallow.data.map((item: { id: any }) => item.id));
    }
  };
  return (
    <>
      <Modal
        open={editOpen}
        title='修改分类'
        okText='修改'
        cancelText='取消'
        okButtonProps={{ autoFocus: true, htmlType: 'submit' }}
        onCancel={() => setEditOpen(false)}
        destroyOnClose
        modalRender={dom => (
          <Form
            layout='vertical'
            form={editForm}
            name='editCategory'
            clearOnDestroy
            onFinish={values => moveMarshmallow(values)}>
            {dom}
          </Form>
        )}>
        <Form.Item
          name='id'
          label='请选择分类'
          rules={[
            {
              required: true,
              message: '请选择分类',
            },
          ]}>
          <Select style={{ width: '100%' }} options={categories} />
        </Form.Item>
      </Modal>
      <Modal
        open={deleteOpen}
        title='批量删除'
        okText='删除'
        okType='danger'
        cancelText='取消'
        onOk={() => deleteMarshmallow()}
        onCancel={() => setDeleteOpen(false)}
        destroyOnClose
        >
        真的要删除这{checkedList.length}个棉花糖投稿吗（不用担心误删，拾雨每天有备份数据）
      </Modal>
      <Card
        title={marshmallow.category}
        bordered={false}
        style={{ width: '100%' }}
        extra={
          editMode ? (
            <Space>
              <Button onClick={() => setEditMode(false)}>退出批量操作</Button>
              <Button onClick={() => selectAll()}>
                {checkedList.length === marshmallow.data.length
                  ? '全不选'
                  : '全选'}
              </Button>
              <Dropdown menu={menuProps}>
                <Button type='primary'>
                  <Space>
                    操作
                    <DownOutlined />
                  </Space>
                </Button>
              </Dropdown>
            </Space>
          ) : (
            <Button onClick={() => setEditMode(true)}>批量操作</Button>
          )
        }>
        <Space direction='vertical' size={'middle'} style={{ width: '100%' }}>
          {marshmallow.data.map((item: { id: any }) => {
            return (
              <MarshmallowCard
                lastRead={lastRead}
                key={item.id}
                data={item}
                editMode={editMode}
                checkedList={checkedList}
                setCheckedList={setCheckedList}
                categories={categories}
              />
            );
          })}
        </Space>
      </Card>
    </>
  );
};

const Dashboard = () => {
  const { data, error, isLoading } = useSWR(
    'https://api.lynne.com.cn/marshmallowManage/list',
    fetcher
  );
  const {
    data: categoryData,
    error: categoryError,
    isLoading: categoryIsLoading,
  } = useSWR('https://api.lynne.com.cn/marshmallowManage/category', fetcher);
  const n = useNavigate();
  const isAnimationComplete = usePageAnimation();
  const [lastRead, setLastRead] = useState(0);
  useEffect(() => {
    // 登录校验
    if (cookie.load('token') === undefined) {
      n('/login');
      return;
    }
    if (isLoading || categoryIsLoading || !data || !isAnimationComplete) {
      return;
    }

    const scroll = sessionStorage.getItem('scroll');
    const last = sessionStorage.getItem('lastRead');
    if (last) {
      setLastRead(parseInt(last));
      sessionStorage.removeItem('lastRead');
    }
    if (scroll) {
      const targetY = parseInt(scroll, 10);
      
      // 这里依然建议保留一个微小的延时 (0ms 或 10ms)
      // 因为 React Context 更新导致重渲染到 DOM 稳定可能需要一帧的时间
      // 但不需要设为 500ms 那么长了
      requestAnimationFrame(() => {
        console.log("执行恢复滚动:", targetY);
        
        window.scrollTo({
          top: targetY,
          behavior: 'smooth' // <--- 关键：开启平滑滚动
        });
        sessionStorage.removeItem('scroll');
      });
    }
  }, [
    n, 
    isLoading, 
    categoryIsLoading, 
    data, 
    isAnimationComplete // <--- 别忘了把这个加入依赖数组
  ]);

  if (isLoading || categoryIsLoading || data === undefined)
    return <Skeleton active />;
  if (error || categoryError) {
    if (
      (error.message && error.message.includes('无效登录')) ||
      (categoryError.message && categoryError.message.includes('无效登录'))
    ) {
        message.error("好像出错了喵");
    }
  }
  
  const categorySelected = categoryData.data.filter(
    (c: { selected: number }) => c.selected === 1
  )[0];
  const marshmallows = [];
  const marshmallowCategories: any[] = [];
  const anchors = [];
  const categories: { value: any; label: any }[] = [];
  for (let i = 0; i < categoryData.data.length; i++) {
    categories.push({
      value: categoryData.data[i].id,
      label: categoryData.data[i].name,
    });
  }
  for (let i = 0; i < data.data.length; i++) {
    if (marshmallowCategories.indexOf(data.data[i].category) === -1) {
      marshmallowCategories.push(data.data[i].category);
      marshmallows.push({
        categoryId: data.data[i].category,
        category: data.data[i].name,
        data: [data.data[i]],
      });
      anchors.push({
        key: `part${data.data[i].category}`,
        href: `#part${data.data[i].category}`,
        title: data.data[i].name,
      });
    } else {
      marshmallows[
        marshmallowCategories.indexOf(data.data[i].category)
      ].data.push(data.data[i]);
    }
  }
  // 渲染数据
  return (
    <>
      <Flex align='center' gap={10}>
        <Button
          type='primary'
          shape='circle'
          icon={<LeftCircleOutlined />}
          onClick={() => n('/marshmallow')}
        />
        <Title level={3} style={{ margin: '15px 0', flex: 1 }}>
          棉花糖管理
        </Title>
      </Flex>
      <Title level={5} style={{ margin: '15px 0' }}>
        当前默认投稿分类：{categorySelected.name}
      </Title>
      <Flex align='center' gap={10} wrap>
        <Button type='primary' onClick={() => n('/dashboard/category')}>
          管理分类
        </Button>
        <Button type='primary' onClick={() => n('/kg')}>
          K歌链接提取
        </Button>
        <Button type='primary' onClick={() => n('/dashboard/song')}>
          歌单管理
        </Button>
        <Button type='primary' onClick={() => n('/dashboard/voiceCategory')}>
          音声管理
        </Button>
        <Button type='primary' onClick={() => n('/dashboard/manage')}>
          其他管理
        </Button>
        <Button type='primary' onClick={() => n('/dashboard/update')}>
          猫猫静悄悄
        </Button>
      </Flex>
      <Divider />
      <Row gutter={16}>
        <Col span={12}>
          <Card variant='borderless'>
            <Statistic
              title='默认分类投稿数'
              value={
                data.data.filter(
                  (item: { category: any }) =>
                    item.category === categorySelected.id
                ).length
              }
              formatter={formatter}
            />
          </Card>
        </Col>
        <Col span={12}>
          <Card variant='borderless'>
            <Statistic
              title='总投稿数'
              value={data.data.length}
              formatter={formatter}
            />
          </Card>
        </Col>
      </Row>
      <Divider />
      <Space direction='vertical' size={'middle'} style={{ width: '100%' }}>
        <Anchor
          direction='horizontal'
          items={anchors}
          targetOffset={25}
          className="anchor"
          style={{
            padding: '2px 15px',
            borderRadius: '8px',
          }}
        />
        {marshmallows.map(marshmallow => {
          return (
            <div
              id={`part${marshmallow.categoryId}`}
              key={marshmallow.category}>
              <MarshmallowCategoryCard
                lastRead={lastRead}
                marshmallow={marshmallow}
                categories={categories}
              />
            </div>
          );
        })}
      </Space>
    </>
  );
};

export default Dashboard;
